import React from 'react'
import './Turbo.css'
import { InlineMath, BlockMath } from "react-katex";
import TurboGame from './TurboGame/TurboGame';
import { renderStatementWithKaTeX } from '../../../../../Functions/WriteLaTex';

const Tubro = () => {
  const TurboProblem =['Turbo the snail plays a game on a board with $2024$ rows and $2023$ columns. There are hidden monsters in $2022$ of the cells. Initially, Turbo does not know where any of the monsters are, but he knows that there is exactly one monster in each row except the first row and the last row, and that each column contains at most one monster. ',
    'Turbo makes a series of attempts to go from the first row to the last row. On each attempt, he chooses to start on any cell in the first row, then repeatedly moves to an adjacent cell sharing a common side. (He is allowed to return to a previously visited cell.) If he reaches a cell with a monster, his attempt ends and he is transported back to the first row to start a new attempt. The monsters do not move, and Turbo remembers whether or not each cell he has visited contains a monster. If he reaches any cell in the last row, his attempt ends and the game is over. ',
    'Determine the minimum value of $n$ for which Turbo has a strategy that guarantees reaching the last row on the $n^{th}$ attempt or earlier, regardless of the locations of the monsters.'
  ]
   
  return (
    <div className='Game'>
      <div className='discription'>
        <h1> IMO 2024 Problem 5 : Turbo</h1>
       
         <h2>- Problem Statement -</h2>
         <div className='Statement'>
            {TurboProblem.map((el)=>(
              <div className='StatementParts'>
                 { renderStatementWithKaTeX(el)}
            
              </div>
              
              ))}
         </div>
         
      </div>
      <TurboGame/>
    </div>
  )
}

export default Tubro
